import styled from 'styled-components';

import { Wrapper as FieldWrapper } from '@rewardopl/react-ui/field/index.styles';
import {
  Label as FieldsetLabel,
  Wrapper as FieldsetWrapper,
} from '@rewardopl/react-ui/fieldset/index.styles';
import { visuallyHidden } from '@rewardopl/react-ui/visually_hidden/index.styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--gap);

  ${FieldsetWrapper} {
    &:first-of-type {
      ${FieldWrapper} {
        &:not(:first-of-type) {
          padding-top: var(--gap);
          border-top: 1px solid var(--gray);
        }
      }
    }
  }

  ${FieldsetLabel} {
    ${visuallyHidden}
  }
`;

export const Label = styled.span`
  font-weight: 500;
`;

export const Value = styled.span`
  display: block;
  margin-top: calc(var(--gap) / 2);
`;
